export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5229.2d086345.jpg";